<div *ngLet="hiddenCountStatistics$ | async as hiddenCountStatistics"
     class="stats-container">
    <div class="layout-row layout-wrap">
        <div *ngFor="let countStat of countStatistics"
             [hidden]="hiddenCountStatistics.includes(countStat.page.title)"
             [ngClass]="[
                'flex-gt-md-' + getLargeScreenSize(hiddenCountStatistics.length),
                'flex-md-' + getMediumScreenSize(hiddenCountStatistics.length),
                'flex-sm-' + getMediumScreenSize(hiddenCountStatistics.length)
             ]"
             class="card-container flex-xs-100">
            <a [routerLink]="[countStat.page?.routerLink]"
               cdkMonitorElementFocus>
                <mat-card class="counter-card">
                    <div class="icon layout-row layout-align-v-center layout-align-h-center">
                        <mat-icon [svgIcon]="countStat.page?.svgIcon"
                                  class="count-color">
                        </mat-icon>
                    </div>
                    <div class="info flex">
                        <h3 *ngIf="countStat.count !== -1"
                            class="counter count-color">
                            {{ countStat.count }}
                        </h3>
                        <h3 *ngIf="countStat.count === -1"
                            translate
                            class="text-muted no-access"
                            [attr.data-cy]="'dashboard-no-access-' + countStat.title">
                            stats_page_access_denied
                        </h3>
                        <p class="text-muted text-nowrap text-uppercase">
                            {{ 'page_' + countStat.title.toLowerCase() | translate }}
                        </p>
                    </div>
                </mat-card>
            </a>
        </div>
    </div>
    <div *ngLet="folderType$ | async as folderType"
         class="layout-row layout-wrap">
        <div flex
             class="card-container flex flex-md-50 flex-xs-100 flex-50">
            <mat-card class="chart-card">
                <mat-card-header>
                    <mat-card-title translate>
                        page_robots
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content *ngIf="folderType === FolderType.Classic; else modernRobotsInfo"
                                  class="chart-content">
                    <ng-container *uiContentLoading="sessionChart.loading$ | async">
                        <ui-pie-chart *ngIf="(sessionChart.hasAccess$ | async) &&
                                        (sessionChart.hasData$ | async)"
                                      [legend]="sessionChart.legend"
                                      [colors]="sessionChart.colors"
                                      [data]="sessionChart.data"
                                      (segmentClick)="onLabelClick('robots', $event)"
                                      doughnutRadiusPercentage="55">
                        </ui-pie-chart>
                        <div *ngIf="(
                                    !(sessionChart.hasAccess$ | async) ||
                                    !(sessionChart.hasData$ | async)
                                ) &&
                                !(sessionChart.loading$ | async)"
                             class="no-chart-message-container"
                             role="alert">
                            <div *ngLet="(sessionChart.hasAccess$ | async) as hasAccess"
                                 class="no-chart-message"
                                 [attr.data-cy]="!hasAccess ?
                                    'dashboard-no-access-Robots':
                                    'dashboard-no-data-Robots'">
                                <ng-container *ngTemplateOutlet="placeholder; context: {
                                        $implicit: { icon: 'uipath:donutChartFallback', text: noInfoAvailable, hasAccess: hasAccess  }
                                      }">
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </mat-card-content>
                <ng-template #modernRobotsInfo>
                    <ng-template #modernRobotsInfoText>
                        <p translate>stats_page_modern_robots_warning_1</p>

                        <p>{{ 'stats_page_modern_robots_warning_2' | translate | translateCut: 0 }}
                            <a routerLink="/user-activity">{{
                                   'stats_page_modern_robots_warning_2' | translate | translateCut: 1
                                }}</a>{{
                                'stats_page_modern_robots_warning_2' | translate | translateCut: 2
                            }}</p>
                    </ng-template>
                    <ng-container *ngTemplateOutlet="placeholder; context: {
                                      $implicit: { icon: 'uipath:donutChartFallback', text: modernRobotsInfoText }
                                    }">
                    </ng-container>
                </ng-template>
            </mat-card>
        </div>
        <div flex
             class="card-container flex flex-md-50 flex-xs-100 flex-50">
            <mat-card class="chart-card">
                <mat-card-header>
                    <mat-card-title translate>
                        page_jobs
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content class="chart-content">
                    <ng-container *uiContentLoading="jobChart.loading$ | async">
                        <ui-pie-chart *ngIf="(jobChart.hasAccess$ | async) &&
                                        (jobChart.hasData$ | async)"
                                      [legend]="jobChart.legend"
                                      [colors]="jobChart.colors"
                                      [data]="jobChart.data"
                                      (segmentClick)="onLabelClick('jobs', $event)"
                                      doughnutRadiusPercentage="55">
                        </ui-pie-chart>
                        <div *ngIf="(
                                    !(jobChart.hasAccess$ | async) ||
                                    !(jobChart.hasData$ | async)
                                ) &&
                                !(jobChart.loading$ | async)"
                             class="no-chart-message-container"
                             role="alert">
                            <div *ngLet="(jobChart.hasAccess$ | async) as hasAccess"
                                 translate
                                 class="no-chart-message"
                                 [attr.data-cy]="!hasAccess ?
                                    'dashboard-no-access-Jobs':
                                    'dashboard-no-data-Jobs'">
                                <ng-container *ngTemplateOutlet="placeholder; context: {
                                        $implicit: { icon: 'uipath:donutChartFallback', text: noInfoAvailable, hasAccess: hasAccess  }
                                      }">
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="layout-row layout-wrap">
        <div class="card-container flex-100">
            <mat-card class="chart-card line-chart-card-with-controls">
                <mat-card-header>
                    <mat-card-title>
                        <div class="chart-name-align">
                            {{ 'page_transactions' | translate }}
                            {{ intervalLabel$ | async }}
                        </div>

                        <ng-container *ngIf="transactionChart.hasAccess$ | async">
                            <button (click)="loadTransactionChart(transactionInterval$.value)"
                                    [matTooltip]="'chart_refresh' | translate"
                                    mat-icon-button
                                    type="button">
                                <mat-icon>refresh</mat-icon>
                            </button>
                            <button [matMenuTriggerFor]="transactionChartMenu"
                                    [matTooltip]="'chart_time_period' | translate"
                                    mat-icon-button
                                    type="button">
                                <mat-icon svgIcon="uipath:More"></mat-icon>
                            </button>
                            <mat-menu #transactionChartMenu="matMenu"
                                      [overlapTrigger]="false">
                                <ng-container *ngLet="(transactionInterval$ | async) as transactionInterval">
                                    <button *ngFor="let interval of defaultTransactionIntervals"
                                            [class.active]="transactionInterval == interval.value"
                                            (click)="onIntervalChange(interval.value)"
                                            mat-menu-item
                                            type="button">
                                        {{ interval.translationKey | translate }}
                                    </button>
                                </ng-container>
                            </mat-menu>
                        </ng-container>
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content class="chart-content">
                    <ng-container *uiContentLoading="transactionChart.loading$ | async">
                        <ui-line-chart *ngIf="(transactionChart.hasAccess$ | async) &&
                                        (transactionChart.hasData$ | async)"
                                       [smooth]="true"
                                       [legend]="transactionChart.legend"
                                       [colors]="transactionChart.colors"
                                       [data]="transactionChart.data"
                                       [fillAreasBelowLines]="true"
                                       [xAxisLabels]="transactionChart.labels"
                                       [tooltipTrigger]="ChartTooltipTrigger.Axis"
                                       [showXAxisTickLines]="true">
                        </ui-line-chart>
                        <div *ngIf="(
                                    !(transactionChart.hasAccess$ | async) ||
                                    !(transactionChart.hasData$ | async)
                                ) &&
                                !(transactionChart.loading$ | async)"
                             class="no-chart-message-container"
                             role="alert">
                            <div *ngLet="(transactionChart.hasAccess$ | async) as hasAccess"
                                 translate
                                 class="no-chart-message"
                                 [attr.data-cy]="!hasAccess ?
                                    'dashboard-no-access-Transactions':
                                    'dashboard-no-data-Transactions'">
                                <ng-container *ngTemplateOutlet="placeholder; context: {
                                        $implicit: { icon: 'uipath:lineChartFallback', text: noInfoAvailable, hasAccess: hasAccess  }
                                      }">
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<ng-template #placeholder
             let-data>
    <mat-card-content class="chart-content chart-content-placeholder">
        <mat-icon [svgIcon]="data.icon"
                  class="fallback-icon"></mat-icon>

        <div class="fallback-text">
            <ng-container *ngTemplateOutlet="data.text; context: { $implicit: { hasAccess: data?.hasAccess } }">
            </ng-container>
        </div>
    </mat-card-content>
</ng-template>

<ng-template #noInfoAvailable
             let-data>
    <ng-container *ngIf="!data.hasAccess; else noData">
        {{ 'access_denied_general' | translate }}
    </ng-container>
    <ng-template #noData>
        {{ 'no_data_general' | translate }}
    </ng-template>
</ng-template>
